import { ExternalAccesoGuard } from './../../../core/guards/deactivate/external-acceso.guard';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccesoCiudadanoComponent } from './pages/acceso-ciudadano/acceso-ciudadano.component';
import { CiudadanoComponent } from './ciudadano.component';
import { HomeCiudadanoComponent } from './pages/home-ciudadano/home-ciudadano.component';

const CIUDADANO_ROUTE: Routes = [{
  path: '',
  component: CiudadanoComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'acces'
    }
    ,
    {
      path: 'acces',
      component: AccesoCiudadanoComponent,
      canActivate: [ExternalAccesoGuard],
      data: {
        authorities: [],
        pageTitle: 'CIUDADANO.title'
      }
    }
    ,
    {
      path: 'home',
      component: HomeCiudadanoComponent,
      data: {
        authorities: [],
        pageTitle: 'CIUDADANO.title'
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(CIUDADANO_ROUTE)],
  exports: [RouterModule]
})
export class CiudadanoRoutingModule { }
